import { httpInstance } from '@/services/httpInstance';

const getIfCanDropDocument = async (documentId) => {
  const endpoint = `/back-office/v1/rootness-document/validate-drop/${documentId}`;
  let res;
  await httpInstance.get(endpoint).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });

  return res;
};

export default getIfCanDropDocument;
